import { CustomLessonViewTag } from '@yandex-int/k-common';
import React, { ReactNode } from 'react';

import { CustomLessonViewDescription } from '../__description/custom-lesson-view__description';
import { CustomLessonViewImage } from '../__image/custom-lesson-view__image';
import { CustomLessonViewInfo } from '../__info/custom-lesson-view__info';
import { CustomLessonViewName } from '../__name/custom-lesson-view__name';
import { CustomLessonViewTags } from '../__tags/custom-lesson-view__tags';

import './custom-lesson-view__header.scss';

interface Props {
    description: string | null;
    name: string | null;
    tags: Array<CustomLessonViewTag>;
    imageSrc: string | null;
    controls?: ReactNode;
}

export const CustomLessonViewHeader = React.memo((props: Props) => {
    const { description, imageSrc, name, tags, controls } = props;

    return (
        <div className="custom-lesson-view__header">
            <CustomLessonViewImage src={imageSrc} />
            <CustomLessonViewInfo>
                <CustomLessonViewName text={name} />
                <CustomLessonViewDescription text={description} />
                <CustomLessonViewTags tags={tags} />
                {controls && <div className="lesson-view__content-controls">{controls}</div>}
            </CustomLessonViewInfo>
        </div>
    );
});
